import React from 'react'
import PropTypes from 'prop-types'
import styles from 'layouts/DoublePanelViewLayout/DoublePanelViewLayout.module.scss'
import { Button, Icon } from 'gu-ui-kit'

export const CloseButton = ({ onClose = () => {} }) => (
  <Button
    noLabel
    variant={'ghost'}
    className={styles['layout__close-button']}
    onClick={onClose}
    size={'m'}
    color={'Interface-Eighth'}
    startIcon={<Icon name="close" />}
  />
)

CloseButton.propTypes = {
  onClose: PropTypes.func,
}
